import React from "react";
import classnames from "classnames";
import { getUrl } from "@outplayed/riot-assets";
import { capitalizeFirstLetter } from "lib/general-helper.js";
import { TooltipContainer } from "@outplayed/tooltips";
import { ReactComponent as Penta } from "svg/multikills/penta.svg";
import { ReactComponent as Quadra } from "svg/multikills/quadra.svg";
import { ReactComponent as Triple } from "svg/multikills/triple.svg";
import { ReactComponent as Double } from "svg/multikills/double.svg";

function getMultiKillIcon(multikill) {
  switch (multikill) {
    case "penta":
      return Penta;
    case "quadra":
      return Quadra;
    case "triple":
      return Triple;
    case "double":
      return Double;
    default:
      return null;
  }
}

const MultikillIndicator = (props) => {
  const { multiKillType, disableText, enableTooltip } = props;

  if (!multiKillType) {
    return null;
  }

  const MultiKillIcon = getMultiKillIcon(multiKillType);
  const multikillLabel = `${capitalizeFirstLetter(multiKillType)}`;

  const html = (
    <div className={classnames("multikill-indicator-container", multiKillType)}>
      {MultiKillIcon && (
        <div className={classnames("multikill-icon", multiKillType)}>
          <MultiKillIcon />
        </div>
      )}
      {!disableText && <div className="multikill-text">{multikillLabel}</div>}
    </div>
  );

  if (enableTooltip) {
    return <TooltipContainer tooltipInfo={multikillLabel}>{html}</TooltipContainer>;
  }

  return html;
};

export default MultikillIndicator;
